import type { CityConfig } from "../city-template/types";

export const evansvilleConfig: CityConfig = {
  city: "Evansville",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "evansville",
  route: "/cities/evansville",
  title: "Emergency Passport Evansville IN | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Evansville, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Evansville, Newburgh, Mount Vernon, Boonville, and all Southwest Indiana residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Evansville, IN",
  heroSubtitle: "Evansville travelers — from the University of Evansville campus to the Ohio River manufacturing corridor to the Southwest Indiana medical community — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Vanderburgh County and Southwest Indiana.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Evansville%20Indiana%20skyline%20along%20the%20Ohio%20River%20with%20the%20historic%20Four%20Freedom%20Monument%2C%20modern%20riverfront%20buildings%20and%20the%20Tropicana%20Evansville%20casino%20visible%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%2C%20vibrant%20Southwest%20Indiana%20riverfront%20atmosphere%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20warm%20tones%20and%20riverfront%20charm&width=1800&height=700&seq=evansville-hero-001&orientation=landscape",
  heroImageAlt: "Evansville Indiana skyline along the Ohio River with Four Freedom Monument and riverfront",
  geoPosition: "37.9716;-87.5711",
  geoPlacename: "Evansville, Indiana",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S. Dearborn St, 17th Floor, Chicago, IL 60604",
    distance: "Approximately 4 hours north of Evansville via I-57/I-80",
  },
  nearbyCitiesZips: [
    { name: "Evansville", zips: "47701, 47702, 47703, 47704, 47705, 47706, 47708, 47710, 47711, 47712, 47713, 47714, 47715, 47716, 47718, 47719, 47720, 47721, 47722, 47724, 47725, 47728, 47730, 47731, 47732, 47733, 47734, 47735, 47736, 47737, 47739, 47740, 47744, 47747, 47750" },
    { name: "Newburgh", zips: "47629, 47630" },
    { name: "Mount Vernon", zips: "47620" },
    { name: "Boonville", zips: "47601" },
    { name: "Princeton", zips: "47670" },
    { name: "Vincennes", zips: "47591" },
    { name: "Washington", zips: "47501" },
    { name: "Henderson", zips: "42420" },
    { name: "Owensboro", zips: "42301, 42302, 42303" },
    { name: "Jasper", zips: "47546, 47547" },
    { name: "Tell City", zips: "47586" },
    { name: "Santa Claus", zips: "47579" },
    { name: "Terre Haute", zips: "47801, 47802, 47803, 47804, 47805, 47807, 47808, 47809" },
    { name: "Bloomington", zips: "47401, 47403, 47404, 47405, 47406, 47408" },
    { name: "Indianapolis", zips: "46201, 46202, 46203, 46204, 46205, 46206, 46208, 46214, 46217, 46218, 46219, 46220, 46221, 46222, 46224, 46225, 46226, 46227, 46228, 46229, 46231, 46234, 46235, 46236, 46237, 46239, 46240, 46241, 46250, 46254, 46256, 46259, 46260, 46268, 46278, 46280, 46290" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago or Indianapolis — our couriers pick the fastest route" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Southwest Indiana Hub", desc: "Serving University of Evansville, St. Vincent, and Deaconess health travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no road trip to Chicago or Indianapolis required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Fort Wayne, IN", route: "/cities/fort-wayne" },
    { name: "Urgent passport services in Carmel, IN", route: "/cities/carmel" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Evansville, Indiana remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4 hours north via I-57/I-80) or Indianapolis Passport Agency (3 hours northeast via I-69) — whichever is fastest. Evansville residents can ship from any UPS or FedEx in Vanderburgh County.",
  fpcOfficeDistance: "Serving Evansville, Newburgh, Mount Vernon, Boonville, Princeton, Vincennes, Washington, Henderson, Owensboro, Jasper, Tell City, and all of Southwest Indiana and the Tri-State Area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Evansville and Southwest Indiana. From downtown Evansville near the Ohio River to the University of Evansville campus, from Newburgh to the Mount Vernon and Boonville communities — we serve all of Vanderburgh County and beyond.",
  nearbyCitiesIntro: "We serve Evansville and all nearby communities including Newburgh, Mount Vernon, Boonville, Princeton, Vincennes, Washington, Henderson, Owensboro, Jasper, Tell City, Santa Claus, and all of the Indiana-Kentucky-Illinois Tri-State Area. We also serve western Kentucky communities and southern Illinois.",
  howItWorksIntro: "Most Evansville travelers complete everything online and ship documents overnight. No need to drive 4 hours to Chicago or 3 hours to Indianapolis — our couriers handle both agencies and always pick the fastest route.",
  mistakesIntro: "Evansville is a major Southwest Indiana hub with significant university travel from the University of Evansville, medical travel from St. Vincent and Deaconess, and manufacturing business from the Ohio River corridor. Here are the most common passport mistakes we see from Southwest Indiana travelers.",
  testimonialsIntro: "Evansville travelers — from University of Evansville students to healthcare professionals to Tri-State Area families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Evansville, IN? Here are the most common ones we hear from Southwest Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 4 hours to Chicago or 3 hours to Indianapolis", "Full day commitment — difficult from Evansville"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago or Indianapolis agency — fastest option chosen", "No long drive required", "Perfect for university and medical travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago or Indianapolis agency — fastest option chosen", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Evansville travelers with immediate departure needs — as fast as 24 hours. Our couriers use Chicago or Indianapolis agency — whichever is fastest.",
      bullets: ["24–48 hour turnaround available", "Chicago or Indianapolis agency — fastest route chosen", "Southwest Indiana university and medical travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Evansville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Southwest Indiana address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Evansville residents and families — including University of Evansville students, new citizens, and Southwest Indiana families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Evansville residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Evansville and Southwest Indiana families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Evansville and Southwest Indiana residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Evansville IN", description: "Urgent passport processing for Evansville Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Evansville IN", description: "Fast passport renewal for Evansville Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Evansville IN", description: "New passport application services for Evansville Indiana residents applying for their first passport." },
    { name: "Child Passport Evansville IN", description: "Minor passport services for Evansville Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Elizabeth R.",
      location: "Evansville, IN",
      rating: 5,
      text: "Medical conference in London in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 3 days. I shipped from the UPS Store on Green River and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael K.",
      location: "Newburgh, IN",
      rating: 5,
      text: "Family vacation to the Bahamas with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Bell Road and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Sarah J.",
      location: "Mount Vernon, IN",
      rating: 5,
      text: "Business trip to Tokyo with 9 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for Southwest Indiana.",
      service: "Emergency Passport",
    },
    {
      name: "David W.",
      location: "Evansville, IN",
      rating: 5,
      text: "Lost my passport the week before a study abroad semester in Ireland. Fast Passport Center replaced it in 48 hours. As a University of Evansville student, I couldn't afford to miss my program. They saved my semester.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "evv-1",
      name: "Evansville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "800 Sycamore St",
      city: "Evansville",
      state: "IN",
      zip: "47708",
      phone: "(812) 422-5311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Evansville, near the Ohio River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Evansville acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers.",
      icon: "ri-mail-line",
    },
    {
      id: "evv-2",
      name: "East Side Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 E Walnut St",
      city: "Evansville",
      state: "IN",
      zip: "47714",
      phone: "(812) 477-6271",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Side Evansville, approximately 2 miles from downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for east side Evansville and Newburgh residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "evv-3",
      name: "Newburgh Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5220 State Route 66",
      city: "Newburgh",
      state: "IN",
      zip: "47630",
      phone: "(812) 858-3411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Newburgh, approximately 8 miles east of Evansville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Newburgh and eastern Warrick County. Good alternative for east-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "evv-4",
      name: "Vincennes Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "420 Broadway St",
      city: "Vincennes",
      state: "IN",
      zip: "47591",
      phone: "(812) 882-5397",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vincennes, approximately 50 miles north of Evansville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Vincennes and northern Knox County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "evv-5",
      name: "Vanderburgh County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1 NW Martin Luther King Jr Blvd",
      city: "Evansville",
      state: "IN",
      zip: "47708",
      phone: "(812) 435-5160",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Evansville Civic Center",
      website: "https://www.vanderburghgov.org/",
      websiteLabel: "Vanderburgh County",
      notes: "County Clerk passport acceptance. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Chicago", fpc: "No — ship from Evansville" },
    { feature: "Agency Selection", agency: "Must choose one yourself", fpc: "We pick Chicago or Indianapolis — fastest available" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Evansville medical professionals and university students often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Green River Road or Lloyd Expressway sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Vanderburgh County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Evansville Post Office appointments fill during summer and winter break seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Chicago or Indianapolis",
      description: "Many Evansville residents attempt to drive to a passport agency in an emergency. The 3–4 hour drive each way means a full day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring and summer travel from EVV peaks March through August.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Evansville area or Southwest Indiana." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Green River Road or Lloyd Expressway." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to Chicago or Indianapolis Passport Agency — whichever is fastest for you." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Evansville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Evansville, IN?", a: "Fast Passport Center offers emergency passport processing in Evansville, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4 hours north via I-57/I-80) or Indianapolis Passport Agency (3 hours northeast via I-69) — whichever is fastest." },
    { q: "Does Evansville have its own passport agency?", a: "No — Evansville does not have a regional passport agency. The nearest facilities are the Chicago Passport Agency (approximately 4 hours north via I-57/I-80) and the Indianapolis Passport Agency (approximately 3 hours northeast via I-69). Fast Passport Center's courier service means Evansville residents never need to make either drive." },
    { q: "Can I get an expedited passport in Newburgh, Mount Vernon, or Henderson?", a: "Absolutely. Fast Passport Center serves all of Southwest Indiana including Newburgh, Mount Vernon, Boonville, Princeton, Vincennes, Henderson, Owensboro, and all of the Indiana-Kentucky-Illinois Tri-State Area. Our service works the same way everywhere." },
    { q: "What airport do Evansville travelers use for international flights?", a: "Evansville Regional Airport (EVV) is the primary airport for Evansville and Southwest Indiana. EVV offers direct flights to Atlanta, Chicago, Dallas, and Detroit, with international connections through those hubs. Nashville International (BNA) is also an option 2 hours south. Always verify passport validity for at least 6 months past your return date." },
    { q: "Should I use Chicago or Indianapolis for my passport?", a: "It depends on your timeline. The Indianapolis Passport Agency is 3 hours northeast via I-69 and may be less busy than Chicago. For some cases, it offers faster appointments. Fast Passport Center's couriers serve both agencies — we always choose the fastest option for your timeline." },
    { q: "How much does an expedited passport cost in Evansville, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Evansville?", a: "Walgreens, CVS, and Walmart stores throughout Evansville offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve University of Evansville students?", a: "Yes. Fast Passport Center serves all of Southwest Indiana including University of Evansville students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our courier service is especially valuable for students who can't take a day off to drive to Chicago or Indianapolis." },
  ],
  photoLocations: [
    { name: "Walgreens — Green River Evansville", address: "3000 N Green River Rd, Evansville, IN 47715", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart — Evansville", address: "401 N Burkhardt Rd, Evansville, IN 47715", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Evansville", address: "5020 E Lloyd Expy, Evansville, IN 47715", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Evansville", address: "430 S Rosenberger Ave, Evansville, IN 47712", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Evansville", address: "4430 N First Ave, Evansville, IN 47710", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended.", featured: true },
    { name: "Indiana BMV — Newburgh", address: "7755 W State Road 66, Newburgh, IN 47630", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Newburgh and eastern Warrick County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "EVV",
      name: "Evansville Regional Airport",
      distance: "4 miles north of downtown Evansville",
      address: "7801 Bussing Rd, Evansville, IN 47725",
      note: "Primary airport for Evansville and Southwest Indiana. Direct flights to Atlanta, Chicago, Dallas, and Detroit. Most international travel connects through Chicago O'Hare (ORD), Atlanta (ATL), or Detroit (DTW).",
      flightUrl: "https://www.evansvilleairport.com/",
      flightLabel: "EVV Flight Info",
      featured: true,
    },
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "Approximately 3 hours northeast of Evansville via I-69",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Alternative airport for Evansville travelers. Direct flights to Toronto, Cancun, and Paris (seasonal). Larger hub with more domestic and international connections.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: false,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "Approximately 2 hours south of Evansville via I-69",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Alternative airport for Evansville travelers heading south. Southwest hub with domestic and international connections.",
      flightUrl: "https://www.flynashville.com/",
      flightLabel: "BNA Flight Info",
      featured: false,
    },
  ],
};